module.exports = __webpack_public_path__ + "img/aforo.bb3bdee5.png";